export const buildPrintModel = (ip, printer, detail_id, client_name, ref, color, mts, kg, person) => {
    return {
        ip,
        printer,
        detail_id,
        client_name,
        ref: `Ref: ${ref}`,
        color: `Color: ${color}`,
        mts: `Mts: ${mts}`,
        kg: `Kg: ${kg}`,
        person
    }
}

export const buildPrintRolModel = (ip, printer, desc, ref, color, mts, person, detail_id = '' ) => {
    return {
        ip,
        printer,
        desc,
        ref: `Ref: ${ref}`,
        color: `Color: ${color}`,
        mts: `Mts: ${mts}`,
        person: `Operario: ${person}`,
        detail_id
    }
}

export const buildPrintOrderEanModel = (ip, printer, ref, color, mts, person, detail_id = '', client_name, client_cod, ref_description, ean, oc ) => {
    return {
        ip,
        printer,
        ref: `Ref: ${ref}`,
        color: `Color: ${color}`,
        mts: `${mts}`,
        kg: '',
        person: `Op: ${person}`,
        client_name,
        detail_id,
        client_cod,
        ref_description,
        ean,
        oc
    }
}

export const buildPrintOrderEanReymonModel = (ip, printer, ref, color, mts, person, detail_id = '', _, client_cod, ref_description, ean, oc ) => {
    return {
        ip,
        printer,
        ref: `Ref: ${ref}`,
        color: `Ext. 1: ${color} - ${ref_description}`,
        mts: `Cant: ${mts}`,
        kg: '',
        person: `Op: ${person}`,
        client_name: 'Reymon',
        detail_id,
        client_cod,
        ref_description,
        ean,
        oc
    }
}